module.exports = __webpack_public_path__ + "static/media/Home1.b56b916f.png";